import { render } from "./CameraBegging.vue?vue&type=template&id=29738e50&scoped=true&ts=true"
import script from "./CameraBegging.vue?vue&type=script&lang=ts"
export * from "./CameraBegging.vue?vue&type=script&lang=ts"

import "./CameraBegging.vue?vue&type=style&index=0&id=29738e50&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29738e50"]])

export default __exports__